import React, { useEffect, useState } from "react";
import LOGO from "../../assets/images/DERMASTER_NEW_LOGO.png";
import "../../assets/styles/createnewpassword.scss";
import MainButton from "../../components/button/mainButton";
import { Link, useLocation, useHistory } from "react-router-dom";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import axios from "axios";
import { Row, Col, Alert, message, Form, Input, Checkbox } from "antd";

const CreateNewPassword = () => {
  const { search } = useLocation();
  let query = new URLSearchParams(search);

  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);

  const [dataLoaded, setDataLoaded] = useState<boolean>(false);
  const [user, setUser] = useState<any>({});

  const onFinish = async (values: any) => {
    console.log("values =>", values);

    const { password, confirmPassword } = values;

    if (!password) {
      message.warning("กรุณาป้อนรหัสผ่าน!");
      return;
    } else if (!confirmPassword) {
      message.warning("กรุณาป้อนยืนยันรหัสผ่าน!");
      return;
    } else if (password !== confirmPassword) {
      message.warning("รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน!");
      return;
    }

    try {
      setLoading(true);

      const token = query.get("token") || "";

      const body = { password, token };

      const { data }: any = await axios.patch(
        `/users/recover/set-new-password`,
        body
      );
      console.log("data =>", data);

      message.success(
        "กำหนดรหัสผ่านใหม่สำเร็จ คุณสามารถเข้าสู่ระบบด้วยรหัสผ่านใหม่!"
      );

      setTimeout(() => {
        console.log("go to login...");
        history.push(`/`);
      }, 1000);
    } catch (err: any) {
      message.warning("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งในภายหลัง!");
      setLoading(false);
    }
  };

  useEffect(() => {
    getApis();
  }, []);

  const getApis = async () => {
    const token = query.get("token") || "";

    try {
      const ref = await axios.get(`/users/get-user-token?token=${token}`);
      console.log("ref =>", ref);

      if (ref.data) {
        setUser(ref.data);
      }
    } catch (err) {
      message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งในภายหลัง!");
    }

    setDataLoaded(true);
  };
  return (
    <div className="login">
      <div className="container">
        <img className="logo" src={LOGO} alt="Dermaster" />
        <div className="box">
          {!dataLoaded ? (
            <>
              <div className="text-black">กำลังโหลดข้อมูล...</div>
            </>
          ) : (
            <>
              {!user._id ? (
                <>
                  <div className="display-block">
                    <p className="text-black">Token ไม่ถูกต้อง!</p>
                    <p>
                      <Link to="/">Back to log in</Link>
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <Form
                    name="normal_login"
                    className="login-form"
                    layout="vertical"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                  >
                    <div className="box-contant">
                      <div className="label1">สร้างรหัสผ่านใหม่</div>
                      <div className="label1">Create a new password</div>

                      <div className="row">
                        <span className="col-3 subtext-contant-username">
                          Username
                        </span>
                        <span className="col-9 subtext-contant-email">
                          {user.username}
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-3 subtext-contant-username">
                          Email
                        </span>
                        <span className="col-6 subtext-contant-email">
                          {user.email}
                        </span>
                      </div>
                      <Form.Item name="password">
                        <Input.Password
                          className="input-password"
                          placeholder="New Password"
                        />
                      </Form.Item>

                      <Form.Item name="confirmPassword">
                        <Input.Password
                          className="input-password"
                          placeholder="Confirm New Password"
                          iconRender={(visible) =>
                            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                          }
                        />
                      </Form.Item>

                      <div style={{ marginTop: "10px" }}>
                        <MainButton
                          title="RESET PASSWORD"
                          to="/"
                          width="320px"
                          background="#5BAEA9"
                          isSubmit={true}
                          loading={loading}
                        />
                      </div>
                    </div>
                  </Form>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default CreateNewPassword;
